<template>
<div style="display: inline;">
    <vxe-pulldown ref="attachmentRef" popup-class-name="file-list-dropdown" transfer>
        <template #default>
            <vxe-button mode="text" icon="vxe-icon-num-list" @click="clickEvent"></vxe-button>
        </template>
        <template #dropdown>
            <div class="file-list-dropdown">
                <vxe-table border auto-resize height="auto" max-height="450px"
                           style="border: solid lightgray 2px; border-radius: 4px;"
                           :loading="isLoading" :data="tableData">
                    <vxe-column title="文件名" field="FileName"></vxe-column>
                    <vxe-column title="上传时间" field="UploadTime"></vxe-column>
                    <vxe-column title="备注" field="Remark"></vxe-column>
                    <vxe-column align="center">
                        <template #header>
                            <el-tooltip content="刷新" effect="light" placement="top" class="box-item">
                                <vxe-button mode="text" icon="vxe-icon-refresh" @click="refresh()"></vxe-button>
                            </el-tooltip>
                            <el-tooltip content="全部下载" effect="light" placement="top" class="box-item">
                                <vxe-button mode="text" icon="vxe-icon-download" @click="downloadAll()"></vxe-button>
                            </el-tooltip>
                        </template>
                        <template #default="{ row }">
                            <el-tooltip content="删除" effect="light" placement="top" class="box-item">
                                <vxe-button mode="text" icon="vxe-icon-delete" @click="deleteFile(row)"></vxe-button>
                            </el-tooltip>
                            <el-tooltip content="下载" effect="light" placement="top" class="box-item">
                                <vxe-button mode="text" icon="vxe-icon-download" @click="downloadFile(row)"></vxe-button>
                            </el-tooltip>
                        </template>
                    </vxe-column>
                </vxe-table>
            </div>
        </template>
    </vxe-pulldown>
</div>
</template>

<script>
import {
    deleteAttachment,
    downloadFile,
    getAttachFile,
    getAttachFiles,
    getAttachmentData
} from "@/api/utils";

export default {
    name: "AttachmentList",
    props:{
        Id: Number,
        tableName: String,
        rowTitle: String
    },
    data() {
        return  {
            isLoading: true,
            tableData: [],
            dataIsLoaded: false
        }
    },
    async created() {
    },
    watch: {
    },
    methods:{
        async clickEvent() {
            if(this.dataIsLoaded === false){
                await this.getAttachmentTableData();
                this.dataIsLoaded = true;
            }
            const $pulldown = this.$refs.attachmentRef
            if ($pulldown) {
                $pulldown.togglePanel()
            }
            this.isLoading = false;
        },
        async getAttachmentTableData(){
            if(this.Id !== undefined && this.Id > 0){
                let res = await getAttachmentData(this.tableName, this.Id).catch(() => {});
                if(res["Code"] === 1){
                    this.tableData = res["Data"];
                }
            }
        },
        async downloadFile(row) {
            let res = await getAttachFile({ id: row.Id }).catch(() => { });
            downloadFile(res);
            this.$message({
                message: "附件下载成功",
                type: 'success'
            });
        },
        async deleteFile(row){
            this.isLoading = true;
            let id = row.Id * 1;
            // this.attachmentIds.splice(index, 1);
            await deleteAttachment(id, this.Id === undefined || this.Id == null ? 0 : this.Id,
                this.tableName === undefined || this.tableName == null ? '' : this.tableName);
            await this.getAttachmentTableData();
            this.isLoading = false;
        },
        async downloadAll(){
            let ids = this.tableData.map(x => x.Id);
            let name = this.rowTitle === undefined || this.rowTitle == null ? "" : this.rowTitle;
            name += '附件';
            let res = await getAttachFiles(ids, name).catch(() => {});
            downloadFile(res);
            this.$message({
                message: "附件下载成功",
                type: 'success'
            });
        },
        async refresh(){
            this.isLoading = true;
            await this.getAttachmentTableData();
            this.isLoading = false;
        }
    }
}
</script>

<style scoped>
.file-list-dropdown{
    width: 600px;
    border-width: 5px;
    max-height: 450px;
}
</style>
